export default __webpack_public_path__ + "101456d77e361845eee956dd717e287c.svg";